import React from 'react'
import AElement from './AElement'
import CSS from './CategoryLink.module.scss'

/**
 * @param {?string} props.to
 * @param {?string} props.title
 * @param {?string} props.description
 */

const CategoryLink = props => {
  const { to, title, description } = props

  return (
    <article className={CSS.item}>
      <AElement href={to} className={CSS.link}>
        <h3 className={CSS.title}>{title}</h3>
        <p className={CSS.description}>{description}</p>
      </AElement>
    </article>
  )
}

CategoryLink.defaultProps = {
  to: '/'
}

/**
 * @param {React.ReactNode} children
 */

const CategoryLinkList = ({ children }) => {
  return <div className={CSS.list}>{children}</div>
}

CategoryLink.List = CategoryLinkList
export default CategoryLink
